/**
 * Make the draft description safe to put back into the panel as HTML.
 *
 * The description comes from the model, which may have copied a customer email the consultant
 * pasted, and it is saved with the draft and reopened later : whatever markup it carries would
 * run on every open. Each kept tag is rebuilt from scratch with only the attributes it needs ;
 * nothing of the original tag is copied through, and every other `<` ends up as plain text.
 */

//the shapes the prompt asks for, plus what a contenteditable produces when the consultant edits
var KEPT_TAGS = ["p", "div", "span", "br", "ul", "ol", "li", "b", "strong", "i", "em", "u", "s",
    "blockquote", "pre", "code", "h1", "h2", "h3", "h4"] ;
//their content is code, never text the consultant wrote : dropped along with the tag
var DROPPED_WITH_CONTENT = ["script", "style", "iframe", "object", "noscript", "template", "textarea", "title"] ;

var SAFE_HREF = /^(https?:\/\/|mailto:)/i ;
//a pasted image travels inline until the server extracts it into an attachment
var SAFE_IMAGE = /^data:image\/(png|jpe?g|gif|webp);base64,[a-z0-9+/=\s]+$/i ;

function escapeText(s){
    return s.replace(/</g, "&lt;").replace(/>/g, "&gt;") ;
}

function escapeAttribute(s){
    return s.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;") ;
}

function decodeEntities(s){
    return s.replace(/&#x([0-9a-f]+);?/gi, function(m, hex){ return String.fromCharCode(parseInt(hex, 16)) ; })
        .replace(/&#([0-9]+);?/g, function(m, dec){ return String.fromCharCode(parseInt(dec, 10)) ; })
        .replace(/&colon;/gi, ":").replace(/&tab;/gi, "\t").replace(/&newline;/gi, "\n")
        .replace(/&quot;/gi, "\"").replace(/&amp;/gi, "&") ;
}

function readAttribute(attrs, name){
    var m = attrs.match(new RegExp("(?:^|\\s)" + name + "\\s*=\\s*(?:\"([^\"]*)\"|'([^']*)'|([^\\s\"'>]+))", "i")) ;
    if(!m){ return "" ; }
    //browsers ignore control characters and spaces inside a scheme : `java\tscript:` still runs
    return decodeEntities(m[1] || m[2] || m[3] || "").replace(/[\u0000-\u0020]/g, "") ;
}

function rebuildTag(name, attrs, closing){
    if(closing){
        return (name === "br" || name === "img") ? "" : "</" + name + ">" ;
    }
    if(name === "a"){
        var href = readAttribute(attrs, "href") ;
        return SAFE_HREF.test(href)
            ? "<a href=\"" + escapeAttribute(href) + "\" target=\"_blank\" rel=\"noopener noreferrer\">"
            : "<a>" ;
    }
    if(name === "img"){
        var src = readAttribute(attrs, "src") ;
        return SAFE_IMAGE.test(src) ? "<img src=\"" + escapeAttribute(src) + "\">" : "" ;
    }
    return "<" + name + ">" ;
}

function sanitizeDraftHtml(html){
    if(html === null || html === undefined){ return "" ; }
    var input = String(html).replace(/<!--[\s\S]*?(-->|$)/g, "") ;
    DROPPED_WITH_CONTENT.forEach(function(tag){
        input = input.replace(new RegExp("<" + tag + "\\b[\\s\\S]*?(<\\/" + tag + "\\s*>|$)", "gi"), "") ;
    }) ;

    var out = "" ;
    var tagPattern = /<(\/?)([a-z][a-z0-9]*)\b((?:"[^"]*"|'[^']*'|[^'">])*)>/gi ;
    var last = 0 ;
    var m ;
    while((m = tagPattern.exec(input)) !== null){
        out += escapeText(input.substring(last, m.index)) ;
        last = tagPattern.lastIndex ;
        var name = m[2].toLowerCase() ;
        if(KEPT_TAGS.indexOf(name) !== -1 || name === "a" || name === "img"){
            out += rebuildTag(name, m[3], m[1] === "/") ;
        }
    }
    out += escapeText(input.substring(last)) ;
    return out ;
}

module.exports = { sanitizeDraftHtml: sanitizeDraftHtml } ;
